import { RouteHelper } from '@/helpers/Route'
import { StatusHelper } from '@/helpers/Status'
import {
  ROUTE_INDEX_APPLICATION_ADMIN_DATA,
  ROUTE_INDEX_APPLICATION_EXISTING_CUSTOMER_DATA,
  ROUTE_INDEX_APPLICATION_HEALTHQUESTIONS,
  ROUTE_INDEX_APPLICATION_ONBOARDING,
  ROUTE_INDEX_APPLICATION_PERSONAL_DATA,
  ROUTE_INDEX_BASKET,
} from '@/config/constants'
import {PersonHelper} from '@/helpers/Person'

function routeToPerson(route, to, next) {
  const basket = RouteHelper.getBasket()
  const isBasketValid = StatusHelper.basketIsValid(basket)

  if (basket.persons.length === 0 || !isBasketValid) {
    next({ name: RouteHelper.getNextRoute(basket) })
  } else if (!to.params.personId) {
    const personId = PersonHelper.getPersonsToValidate(basket)[0].personId
    next({
      name: route,
      replace: true,
      params: {
        personId,
      },
    })
  } else {
    next()
  }
}

function rerouteInvalidBasket(_to, _from, next) {
  const basket = RouteHelper.getBasket()
  const isBasketValid = StatusHelper.basketIsValid(basket)
  if (basket.persons.length === 0 || !isBasketValid) {
    next({ name: RouteHelper.getNextRoute(basket) })
  } else {
    next()
  }
}

export default [
  {
    beforeEnter: (to, from, next) => {
      const basket = RouteHelper.getBasket()
      if (from.meta.index <= ROUTE_INDEX_BASKET && StatusHelper.isOnboardingSecured(basket)) {
        const nextRoute = RouteHelper.getNextAvailableRoute(to, { index: ROUTE_INDEX_APPLICATION_ONBOARDING })
        next(nextRoute.path)
      } else {
        next()
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "screen-application-onboarding" */ '@/modules/Configurator/screens/Application/Onboarding'
      ),
    meta: {
      index: ROUTE_INDEX_APPLICATION_ONBOARDING,
      basket: {
        readonly: true,
      },
    },
    name: 'application-onboarding',
    path: '/application',
  },
  {
    beforeEnter: (to, _from, next) => {
      routeToPerson('application-personal-data', to, next)
    },
    component: () =>
      import(
        /* webpackChunkName: "screen-application-personal-data" */ '@/modules/Configurator/screens/Application/PersonalData'
      ),
    meta: {
      index: ROUTE_INDEX_APPLICATION_PERSONAL_DATA,
      basket: {
        readonly: true,
      },
    },
    name: 'application-personal-data',
    path: '/application/personal-data/:personId?',
    props: route => ({
      personId: route.params.personId,
    }),
  },
  {
    beforeEnter: rerouteInvalidBasket,
    component: () =>
      import(
        /* webpackChunkName: "screen-application-existing-customer" */ '@/modules/Configurator/screens/Application/ExistingCustomerData'
      ),
    meta: {
      index: ROUTE_INDEX_APPLICATION_EXISTING_CUSTOMER_DATA,
      basket: {
        readonly: true,
      },
    },
    name: 'application-existing-customer-data',
    path: '/application/existing-customer-data',
  },
  {
    beforeEnter: rerouteInvalidBasket,
    component: () =>
      import(
        /* webpackChunkName: "screen-application-admin-data" */ '@/modules/Configurator/screens/Application/AdminData'
      ),
    meta: {
      index: ROUTE_INDEX_APPLICATION_ADMIN_DATA,
      basket: {
        readonly: true,
      },
    },
    name: 'application-administrative-data',
    path: '/application/administrative-data',
  },
  {
    beforeEnter: (to, _from, next) => {
      routeToPerson('application-healthquestions', to, next)
    },
    component: () =>
      import(
        /* webpackChunkName: "screen-application-healthquestions" */ '@/modules/Configurator/screens/Application/Healthquestions'
      ),
    meta: {
      index: ROUTE_INDEX_APPLICATION_HEALTHQUESTIONS,
      basket: {
        readonly: true,
      },
    },
    name: 'application-healthquestions',
    path: '/application/healthquestions/:personId?',
    props: route => ({
      personId: route.params.personId,
    }),
  },
]
